export default "__VITE_ASSET__BNFmNtau__"